import { getSubscriptionStatus } from 'my-core/subscription-utils';

import getOnlineCourseContentMap, { findChild, getNext } from './online-course-content-map';
import {
  ACCESS_LEVELS,
  canViewOnlineCourseBooklet,
  getAllOCActivityIds,
  getPackagePricing,
} from './online-course-utils';
import { onlineCoursePath } from './routes';

export function getContinuePath(onlineCourse, ocUser, ocContentMap) {
  if (onlineCourse.user_access_level <= ACCESS_LEVELS.OVERVIEW) return false;

  const content = ocContentMap || getOnlineCourseContentMap(onlineCourse);
  const activityId = ocUser?.progress?.current?.activity_id;
  if (activityId) {
    const node = findChild(content, c => c.type === 'activity' && c.data.id === activityId);
    if (node) return `${onlineCoursePath(onlineCourse)}${node.fullPath}`;
  }

  // if there is no progress get start page
  const node = getNext(content, n => n.type === 'activity');
  return !!node && `${onlineCoursePath(onlineCourse)}${node.fullPath}`;
}

export function getIsPurchased(ocu, packageType) {
  if (!packageType) {
    return !!ocu?.package_type && ocu.package_type !== 'none';
  } else {
    return ocu?.package_type === packageType || ocu?.package_type === 'pro_practice';
  }
}

export function hasProgress(ocu) {
  return !!ocu?.progress?.current;
}

export function getCanPurchase(
  onlineCourse,
  ocUser,
  subscription,
  userCourse,
  courseSubscription,
  packageType = 'pro',
) {
  if (!onlineCourse) return false;
  if (getIsPurchased(ocUser, packageType)) return false;
  if (canViewOnlineCourseBooklet(onlineCourse, ocUser, subscription, userCourse, courseSubscription, packageType))
    return false;
  switch (onlineCourse.purchase_type) {
    case 'subscription':
      return !['active', 'paused', 'trialing'].includes(getSubscriptionStatus(subscription));
    case 'standard': {
      const [price] = getPackagePricing(onlineCourse, packageType);
      return !!price;
    }
    case 'course_bundle':
      return userCourse?.status !== 'active' && userCourse?.status !== 'pending_payment';
  }
  return false;
}

export function getProgressBreakdown(onlineCourseUser, onlineCourse) {
  // return { total: 50, completed: 15, in_progress: 10 };
  const activityIds = getAllOCActivityIds(onlineCourse);
  const total = activityIds.length;
  let completed = 0;
  let in_progress = 0;
  onlineCourseUser?.progress?.completed?.forEach(p => {
    if (activityIds.includes(p.activity_id)) {
      p.is_completed ? completed++ : in_progress++;
    }
  });
  return {
    total,
    completed,
    in_progress,
    not_started: total - (completed + in_progress),
    percent_completed: total ? parseInt(((completed / total) * 100).toFixed()) : onlineCourseUser?.percent_completed,
  };
}
